// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2WnA2","productName":"Table_productName__RIwMY"};